import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LogDetail } from '../../../../../../../types/log.interface';
import { tryTranslate } from './i18n.utils';
import { ValueChangeComponent } from './value-change.component';

@Component({
  selector: 'ces-measure-detail',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ValueChangeComponent, TranslocoModule],
  templateUrl: './measure-detail.component.html',
})
export class MeasureDetailComponent {
  private readonly translate = inject(TranslocoService);
  private readonly translations = toSignal(this.translate.selectTranslation());
  readonly detail = input.required<LogDetail>();

  readonly entityName = computed(() => {
    this.translations();
    const name = this.detail().entityName;
    if (name) return tryTranslate(this.translate, name);
    return this.getEntityFallbackName();
  });

  readonly attributeName = computed(() => {
    this.translations();
    return this.getAttributeDisplayName(this.detail().attribute || '');
  });

  private getEntityFallbackName(): string {
    const entityKeyMap: Record<string, string> = {
      'campaign-measure': 'history.entities.measure',
      'measure': 'history.entities.measure',
    };
    const key = entityKeyMap[this.detail().entity];
    return key ? this.translate.translate(key) : this.detail().entity;
  }

  private getAttributeDisplayName(attribute: string): string {
    const attributeKeyMap: Record<string, string> = {
      name: 'history.fields.name',
      comment: 'history.fields.comment',
      operator: 'history.fields.operator',
      status: 'history.fields.status',
      value: 'history.fields.value',
    };
    const key = attributeKeyMap[attribute];
    return key ? this.translate.translate(key) : attribute;
  }
}
